
import React from 'react';
import Pricing from './Pricing';
import BillingHistory from './BillingHistory';

class UserAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: 'pricing', 
    };
  }

  handleNav = (view) => {
    this.setState({ currentView: view });
  };

  render() {
    const { currentView } = this.state;

    return (
      <div className="min-h-screen bg-slate-50 text-slate-900">
        {/* Header */}
        <header className="flex items-center justify-between px-6 py-3 bg-slate-900 text-slate-50 shadow">
          <div className="font-semibold text-lg tracking-tight">
            Caredevo Billing
          </div>
          <nav className="flex gap-2">
            <button
              onClick={() => this.handleNav('pricing')}
              className={
                'px-3 py-1 rounded text-sm transition ' +
                (currentView === 'pricing'
                  ? 'bg-sky-500 text-white'
                  : 'bg-slate-800 text-slate-200 hover:bg-slate-700')
              }
            >
              Pricing
            </button>
            <button
              onClick={() => this.handleNav('billing')}
              className={
                'px-3 py-1 rounded text-sm transition ' +
                (currentView === 'billing'
                  ? 'bg-sky-500 text-white'
                  : 'bg-slate-800 text-slate-200 hover:bg-slate-700')
              }
            >
              Billing & History
            </button>
          </nav>
        </header>

        {/* Main */}
        <main className="w-full flex justify-center  px-4 sm:px-6 py-6">
          {currentView === 'pricing' && <Pricing />}
          {currentView === 'billing' && <BillingHistory />}
        </main>
      </div>
    );
  }
}

export default UserAccount;
